/** Returns and array of folder names from any url path string and removes any empty entries
 *  @param  {string}
 *  @return  {array}
 */
const splitUrlByFolderPath = (_location = '') => {
  return _location.split('/').filter((entry) => /\S/.test(entry))
}

/** Find the active section based on url folder path
 *  @param  {array {label, slug}} array of sections objects to search
 *  @param  {string} the full url path
 *  @return  {found, label, slug}
 */
const matchUrlToActiveSection = (_sections, _location) => {
  let matchResult = { found: false, label: null, slug: null }
  _sections.forEach((_section) => {
    const _locationBySlash = splitUrlByFolderPath(_location)
    if (_locationBySlash.length >= 1) {
      const rootUrlPath = _locationBySlash[0]
      if (rootUrlPath.indexOf(_section.slug) > -1) {
        matchResult.found = true
        matchResult.label = _section.label
        matchResult.slug = _section.slug
      }
    }
  })
  return matchResult
}

export { splitUrlByFolderPath, matchUrlToActiveSection }
